import { render, staticRenderFns } from "./CpcDetailMaintain.vue?vue&type=template&id=022c9e3e&scoped=true"
import script from "./CpcDetailMaintain.vue?vue&type=script&lang=js"
export * from "./CpcDetailMaintain.vue?vue&type=script&lang=js"
import style0 from "./CpcDetailMaintain.vue?vue&type=style&index=0&id=022c9e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022c9e3e",
  null
  
)

export default component.exports